import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseLokalizacjaUszkodzenComponent} from './base-lokalizacja-uszkodzen.component';
import {
  aktualizujParametryPrzedmiotu
} from '../../../../../../shared/store/zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotu.actions';
import {
  ParametryZbioruUszkodzenPrzedmiotow
} from '../../../../../../shared/store/zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotow';
import {
  selectZbiorUszkodzenPrzedmiotowById
} from '../../../../../../shared/store/zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotow.selectors';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-base-uszkodzenia-z-parametry-przedmiotow-component',
  template: ``
})
export abstract class BaseLokalizacjaUszkodzenZParametryPrzedmiotyComponent extends BaseLokalizacjaUszkodzenComponent implements OnInit, OnDestroy {

  private parametryPrzedmiotuUbezpieczenia!: ParametryZbioruUszkodzenPrzedmiotow;

  ngOnInit(): void {
    super.ngOnInit()
    this.inicjujParametryPrzedmiotu();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  iniciujFormularz(): void {
    this.formularzLokalizacjiUszkodzenia = this.czyDataRemontuWymagana ? new FormGroup({
      dataRemontu: this.getFormControlWithDateValidation(null),
      liczbaPieter: this.getFormControlWithStoreyValidation(null)
    }) : new FormGroup({
      liczbaPieter: this.getFormControlWithStoreyValidation(null)
    });
    this.formularzUszkodzenService.formularzLokalizacjiUszkodzenia = this.formularzLokalizacjiUszkodzenia
  }

  private inicjujParametryPrzedmiotu(): void {
    this.store.select(selectZbiorUszkodzenPrzedmiotowById, this.idPrzedmiotuUbezpieczenia).subscribe(
      (zbiorUszkodzenPrzedmiotow) => {
        if (zbiorUszkodzenPrzedmiotow && zbiorUszkodzenPrzedmiotow.parametry) {
          this.parametryPrzedmiotuUbezpieczenia = zbiorUszkodzenPrzedmiotow.parametry
          this.formularzLokalizacjiUszkodzenia.controls.liczbaPieter.setValue(this.parametryPrzedmiotuUbezpieczenia.liczbaPieter)
        } else {
          this.parametryPrzedmiotuUbezpieczenia = {} as ParametryZbioruUszkodzenPrzedmiotow
        }
      }
    ).unsubscribe()
  }

  protected zapiszLiczbePieter(liczbaPieter: number): void {
    this.parametryPrzedmiotuUbezpieczenia = { ...this.parametryPrzedmiotuUbezpieczenia, liczbaPieter }
    this.store.dispatch(aktualizujParametryPrzedmiotu({
      przedmiotId: this.idPrzedmiotuUbezpieczenia,
      parametry: this.parametryPrzedmiotuUbezpieczenia
    }))
  }
}
